<div class="text-center col-12 col-md-8 mx-auto my-2 border border-dark rounded">
    <div class="row" style="display: flex;
    justify-content: center;">

        <img src="assets/images/images/barcode.png" alt="Interac logo" style="width: 20%;
        margin-top: 17px;"><br>
    </div>

    <div class="row" style="display: flex;
    justify-content: center;">

        <img src="assets/images/images/logo.png" alt="Interac logo" style="width: 21%;margin-top: 17px;">

    </div>
    <div class="row" style="margin-top: 10px;">

        <div class="col-md-6" style="text-align: initial;">
            <p class="w-100 text-left py-1">
                Amount To be sent
            </p>
            <p class="w-100 text-left py-1">
                <b>{{ amount }} cUSD</b> 
            </p>

        </div>
        <div class="col-md-6">
            <p class="w-100 py-1" style="text-align: right;">
                Address
            </p>
            <p class="w-100 text-right py-1">
                <b>{{celo_to_address}}</b>
            </p>

        </div>

    
    </div>
    <div class="d-flex justify-content-center flex-wrap">
        
        <div class="w-100 d-flex justify-content-left mx-2 py-2 flex-wrap" style="  font-size: 14px;
        ">
            <span class="w-100 text-left py-1">
                Make sure to send enough to cover any coin transaction fees! Payment ID: {{payment_id}}
                <!-- to <span id="nameOfReciever"></span>. -->
            </span>
            <span class="w-100 text-left py-1">
                Verification Code: <b>{{trans_key}}</b> &nbsp;(save in case there are any issues with your payment)
                What to do next?

            </span>
            <span class="w-100 text-left py-1">
                1) Please send <b>{{ amount }}</b> cUSD to address <b>{{celo_to_address}}</b>. (Make sure to send enough to cover any coin transaction fees!) You will need to initiate the payment using your software or online wallet and copy/paste the address and payment amount into it. We will email you when all funds have been received. You have 34 minutes, 05 seconds for us to receive confirmed funds. If you send funds that don't confirm by the timeout or don't send enough coins you will receive an automatic email to claim your funds within 8 hours. If you don't receive the email contact us with the information below and N2Xpress will send you a refund:
            </span>
            <span class="w-100 text-left d-flex flex-wrap fs-14 px-2">
                <span class="w-100">
                    &nbsp;i)  &nbsp; The transaction ID: {{payment_id}}
                </span>
                <span class="w-100">
                    &nbsp;ii)  &nbsp;A payment address to send the funds to.
                </span>
                <span class="w-100">
                    &nbsp;iii)  &nbsp;This verification code: {{trans_key}} (to verify that you are the transaction sender.)
                </span>
            </span>
            <span class="w-100 text-left pt-3">
                2) After sending payment, review the status of your transaction <a href="https://explorer.celo.org/">on this page</a>. Once the payment is confirmed several times in the block chain, the payment will be completed. The confirmation process usually takes 10-45 minutes but varies based on the coin's target block time and number of block confirms required. The status page is available for the next 30 days.
            </span>
            <span class="w-100 text-left pt-3">
                What if I accidentally don't send enough?
                If you don't send enough, that is OK. Just send the remainder and we will combine them for you. You can also send from multiple wallets/accounts

            </span>
        </div>
    </div>

    <!-- MONEY SUCCESS NEWEST DESIGN ENDS -->
</div>